import React, { useState } from 'react';

const STEPS = [
  {
    id: 1,
    title: 'Search for a Location',
    description: 'Type any address or neighborhood in Indianapolis to jump to that area. Hot leads in that ZIP will auto-load!',
    tip: 'Pro tip: Search by ZIP code to see all hot leads in that area instantly.',
    image: '/images/onboard-search.webp'
  },
  {
    id: 2,
    title: 'Draw Your Territory',
    description: 'Use Circle, Rectangle, or Lasso to draw around the homes you want to target. We\'ll find every address inside.',
    tip: 'Pro tip: Smaller selections give more precise results.',
    image: '/images/onboard-draw.webp'
  },
  {
    id: 3,
    title: 'Review Hot Leads',
    description: 'See owner names, property values, and hot lead scores. Owner-occupied homes are marked - perfect for door knocking!',
    tip: '🔥 Hot leads have high-value homes with owner-occupants.',
    image: '/images/onboard-leads.webp'
  },
  {
    id: 4,
    title: 'Export & Close Deals',
    description: 'Export selected leads to CSV for your CRM, or copy addresses to clipboard. Start knocking doors today!',
    tip: 'Pro tip: Filter by owner-occupied for best door-to-door results.',
    image: '/images/onboard-export.webp'
  }
];

function OnboardingGuide({ isVisible, onClose, onComplete }) {
  const [currentStep, setCurrentStep] = useState(0);

  if (!isVisible) return null;

  const step = STEPS[currentStep];
  const isLast = currentStep === STEPS.length - 1;

  const handleNext = () => {
    if (isLast) {
      localStorage.setItem('leadgen_onboarded', 'true');
      onComplete?.();
      onClose();
    } else {
      setCurrentStep(prev => prev + 1);
    }
  };

  const handleSkip = () => {
    localStorage.setItem('leadgen_onboarded', 'true');
    onClose();
  };

  return (
    <div className="onboarding-overlay">
      <div className="onboarding-modal">
        {/* Progress dots */}
        <div className="onboarding-progress">
          {STEPS.map((_, i) => (
            <div
              key={i}
              className={`progress-dot ${i === currentStep ? 'active' : ''} ${i < currentStep ? 'completed' : ''}`}
              onClick={() => setCurrentStep(i)}
            />
          ))}
        </div>

        {/* Step content */}
        <div className="onboarding-content">
          <div className="onboarding-image">
            <img src={step.image} alt={step.title} />
          </div>

          <div className="onboarding-step-number">Step {step.id} of {STEPS.length}</div>
          <h2 className="onboarding-title">{step.title}</h2>
          <p className="onboarding-description">{step.description}</p>

          {step.tip && (
            <div className="onboarding-tip">
              <span className="tip-icon">💡</span>
              {step.tip}
            </div>
          )}
        </div>

        {/* Navigation */}
        <div className="onboarding-nav">
          <button className="onboarding-skip" onClick={handleSkip}>
            Skip Tour
          </button>

          <div className="onboarding-nav-buttons">
            {currentStep > 0 && (
              <button
                className="onboarding-btn secondary"
                onClick={() => setCurrentStep(prev => prev - 1)}
              >
                Back
              </button>
            )}
            <button className="onboarding-btn primary" onClick={handleNext}>
              {isLast ? 'Get Started! 🚀' : 'Next'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OnboardingGuide;
